// Drops an OPTIONAL companion staff file's blob from formData when the
// server couldn't read it, so an unreadable extra file can't silently ride
// along into the roster upload as a "paired" import with no header mapping.
//
// Without this, formData (a raw snapshot of the <form>, taken when
// /get_headers was called) still carries the staff_csv file the operator
// picked, even though the UI has already decided to treat this as an
// ordinary single-file import (staffHeaders came back empty). Submitting
// that formData as-is attaches the file anyway, making
// StudentImport#paired_import? true with no staff_header_mapping --
// which used to make PairedFileCrossCheck report every roster teacher as
// "missing from the staff file", a misleading result rather than an
// honest failure. See docs/student_roster_import.md §2.1.
//
// Returns the warning message to show the operator, or null when there's
// nothing to report (no staff file was attached, or it was read fine).
export const clearUnreadableStaffFile = (formData, json) => {
  if (!json.staff_data_error) return null;

  formData.delete('staff_csv');

  return `The companion staff file could not be read (${json.staff_data_error}) and will be skipped -- `
    + 'this will import as a regular single-file roster.';
};
